import { useDispatch } from "react-redux";
import { setUser } from "../reducers/userReducer";
import { clearNotifications } from "../reducers/notificationReducer";

export const useLogout = () => {
  const dispatch = useDispatch();

  const handleLogout = async () => {
    dispatch(setUser(null));
    dispatch(clearNotifications());
    localStorage.clear();
    sessionStorage.clear();
  };

  return handleLogout;
};
